import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=f5b1caa2&scoped=true&"
import script from "./layout.vue?vue&type=script&lang=js&"
export * from "./layout.vue?vue&type=script&lang=js&"
import style0 from "./layout.vue?vue&type=style&index=0&id=f5b1caa2&prod&lang=scss&"
import style1 from "./layout.vue?vue&type=style&index=1&id=f5b1caa2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b1caa2",
  null
  
)

export default component.exports